import BoardSource from './BoardSource';

export const BoardAliasName: ObjectType<string> = {
  [BoardSource.AmericanBoardofMedicalSpecialties]: 'American Board of Medical Specialties (ABMS)',
};
